// Centralizador de assets de extensões de arquivos
import aviIcon from '../assets/extensions/avi.svg'
import codeIcon from '../assets/extensions/code.svg'
import cssIcon from '../assets/extensions/css.svg'
import docIcon from '../assets/extensions/doc.svg'
import epsIcon from '../assets/extensions/eps.svg'
import htmlIcon from '../assets/extensions/htm.svg'
import jpgIcon from '../assets/extensions/jpg.svg'
import jsIcon from '../assets/extensions/js.svg'
import jsonIcon from '../assets/extensions/json.svg'
import movIcon from '../assets/extensions/mov.svg'
import audioIcon from '../assets/extensions/mp3.svg'
import mp4Icon from '../assets/extensions/mp4.svg'
import pdfIcon from '../assets/extensions/pdf.svg'
import phpIcon from '../assets/extensions/php.svg'
import pngIcon from '../assets/extensions/png.svg'
import pptIcon from '../assets/extensions/ppt.svg'
import psdIcon from '../assets/extensions/psd.svg'
import txtIcon from '../assets/extensions/txt.svg'
import fileIcon from '../assets/extensions/unknown.svg'
import xlsIcon from '../assets/extensions/xls.svg'
import zipIcon from '../assets/extensions/zip.svg'

const fileIconMap = {
  pdf: pdfIcon,
  doc: docIcon,
  docx: docIcon,
  rtf: docIcon,
  txt: txtIcon,
  odt: docIcon,
  psd: psdIcon,
  eps: epsIcon,
  png: pngIcon,
  jpg: jpgIcon,
  jpeg: jpgIcon,
  xls: xlsIcon,
  xlsx: xlsIcon,
  csv: xlsIcon,
  xlsm: xlsIcon,
  ppt: pptIcon,
  pptx: pptIcon,
  zip: zipIcon,
  rar: zipIcon,
  '7z': zipIcon,
  tar: zipIcon,
  gz: zipIcon,
  js: jsIcon,
  html: htmlIcon,
  htm: htmlIcon,
  css: cssIcon,
  php: phpIcon,
  py: codeIcon,
  java: codeIcon,
  json: jsonIcon,
  mp4: mp4Icon,
  mov: movIcon,
  avi: aviIcon,
  mp3: audioIcon,
  wav: audioIcon
}

/**
 * Retorna o caminho do ícone SVG baseado no nome do arquivo ou no MimeType nativo.
 * @param {string} fileName - Nome do arquivo (ex: 'documento.pdf')
 * @param {string} mimeType - Tipo MIME opcional do arquivo (ex: 'video/mp4')
 * @returns {string} - Caminho do asset SVG importado
 */
export const getFileIconSrc = (fileName = '', mimeType = '') => {
  const type = String(mimeType).toLowerCase()
  
  if (type.startsWith('video/')) return movIcon
  if (type.startsWith('audio/')) return audioIcon

  const extension = String(fileName).split('.').pop().toLowerCase()
  return fileIconMap[extension] || fileIcon
}